import { Mapper } from './mapper';

export const RacaCor = Mapper.from([
  [1, 'Branca'],
  [2, 'Preta'],
  [3, 'Parda'],
  [4, 'Amarela'],
  [5, 'Indígena'],
]);
